var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.773,
    height: 44.31,
    viewBox: "0 0 37.773 44.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gift_Icon_White",
    "data-name": "Gift Icon White",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gift_Icon_White-2",
    "data-name": "Gift Icon White",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M88.4,58.334c1.186.823,3.148,1.187,6.068,1.187h7.8c2.875,0,4.881-.412,6.068-1.187,2.92-2.011,3.832-5.849,1.962-8.542a5.8,5.8,0,0,0-4.835-2.467,6.786,6.786,0,0,0-3.832,1.187c-1.369.914-2.463,3.015-3.238,5.025-.774-1.966-1.87-4.066-3.238-5.025a6.786,6.786,0,0,0-3.832-1.187,5.8,5.8,0,0,0-4.835,2.467C84.575,52.485,85.487,56.323,88.4,58.334Zm14.646-7.676a4.2,4.2,0,0,1,2.371-.775,3.248,3.248,0,0,1,2.737,1.371,3.687,3.687,0,0,1-1.279,4.98c-.318.228-1.458.73-4.607.73-.867,0-1.687-.045-2.326-.091C100.676,54.358,101.91,51.388,103.05,50.658Zm-14.508.6a3.248,3.248,0,0,1,2.737-1.371,4.193,4.193,0,0,1,2.371.775c1.1.776,2.371,3.745,3.148,6.212-.639.046-1.458.091-2.326.091-3.148,0-4.244-.5-4.607-.73C88.086,55,87.492,52.759,88.543,51.253Z",
    transform: "translate(-79.464 -47.325)",
    fill: "#4681c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M60.624,105.83v6.9a1.344,1.344,0,0,0,1.343,1.345H76.788v-9.594H61.967A1.344,1.344,0,0,0,60.624,105.83Z",
    transform: "translate(-60.624 -90.645)",
    fill: "#4681c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M164.878,104.485H150.117v9.594h14.761a1.344,1.344,0,0,0,1.343-1.345v-6.9A1.344,1.344,0,0,0,164.878,104.485Z",
    transform: "translate(-128.448 -90.645)",
    fill: "#4681c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M70.615,152.241v16.543a1.344,1.344,0,0,0,1.343,1.345h12.4V150.9h-12.4A1.344,1.344,0,0,0,70.615,152.241Z",
    transform: "translate(-68.196 -125.818)",
    fill: "#4681c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M162.459,150.9H150.117v19.232h12.342a1.344,1.344,0,0,0,1.343-1.345V152.241A1.344,1.344,0,0,0,162.459,150.9Z",
    transform: "translate(-128.448 -125.818)",
    fill: "#4681c2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M21.669,44.31V25.078H34.011a1.344,1.344,0,0,1,1.343,1.345V42.966a1.344,1.344,0,0,1-1.343,1.345Zm-17.907,0a1.344,1.344,0,0,1-1.343-1.345V26.422a1.344,1.344,0,0,1,1.343-1.345h12.4V44.31ZM21.669,23.434V13.84H36.43a1.343,1.343,0,0,1,1.343,1.345v6.9a1.343,1.343,0,0,1-1.343,1.345Zm-20.326,0A1.344,1.344,0,0,1,0,22.089v-6.9A1.344,1.344,0,0,1,1.343,13.84H16.164v9.593ZM15.009,12.2c-2.92,0-4.882-.364-6.068-1.187C6.023,9,5.111,5.161,7.028,2.467A5.794,5.794,0,0,1,11.863,0,6.786,6.786,0,0,1,15.7,1.187c1.369.959,2.464,3.06,3.238,5.025C19.709,4.2,20.8,2.1,22.172,1.187A6.786,6.786,0,0,1,26,0a5.8,5.8,0,0,1,4.835,2.467C32.71,5.161,31.8,9,28.877,11.009c-1.188.775-3.193,1.187-6.069,1.187Zm8.577-8.863c-1.141.73-2.374,3.7-3.1,6.215.639.046,1.459.091,2.326.091,3.148,0,4.289-.5,4.607-.73a3.687,3.687,0,0,0,1.279-4.98,3.248,3.248,0,0,0-2.737-1.37A4.2,4.2,0,0,0,23.586,3.333ZM9.079,3.928C8.028,5.434,8.622,7.673,10.4,8.906c.363.228,1.458.73,4.607.73.867,0,1.686-.045,2.326-.091-.777-2.467-2.053-5.436-3.148-6.212a4.192,4.192,0,0,0-2.371-.776A3.248,3.248,0,0,0,9.079,3.928Z",
    transform: "translate(0 0)",
    fill: "#4681c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.a3325985.svg";
export { ForwardRef as ReactComponent };